import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  toastMessage: {
    minHeight: '48px',
    borderRadius: '12px',
    padding: '12px 16px',
    border: '1px solid rgba(255,255,255,0.3)',
    backgroundColor: theme.new.color.text.primary,
    color: theme.new.color.common.white,
    display: 'flex',
    alignItems: 'center',
    minWidth: '300px',
    maxWidth: '600px',
    pointerEvents: 'auto',
    mb: 1,
    '& svg': {
      display: 'flex',
      alignItems: 'center',
      width: 16,
      height: 16,
      color: theme.new.color.common.white,
      stroke: theme.new.color.common.white,
    },
    '&.toast-warning svg, &.toast-info svg': {
      fill: theme.new.color.common.white,
    },
  },
  toastIconCloseButton: {
    ml: 1,
    '&:focus': {
      outline: `2px solid ${theme.new.color.common.white}`,
      outlineOffset: '2px',
    },
  },
  toastIconCloseButtonIcon: {
    '& path': {
      stroke: theme.new.color.common.white,
    },
  },
}));

export default useStyles;
